module.exports = __webpack_public_path__ + "img/brands_image_9.0f34aef7.png";